import { Label } from "./ui/label";

export const Field = ({ id, label, error, hint, children, className = "" }) => (
  <div className={className}>
    <Label htmlFor={id} className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">{label}</Label>
    <div className="mt-1.5">{children}</div>
    {error ? (
      <p className="mt-1.5 text-xs text-red-600" data-testid={`error-${id.replace(/\./g, "-")}`}>{error}</p>
    ) : hint ? (
      <p className="mt-1.5 text-xs text-slate-500">{hint}</p>
    ) : null}
  </div>
);
